/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0",
    versionName: "local 0.2.0",
    versionChannel: "local",
    buildDate: "2026-06-05T03:17:51.008Z",
    commitHash: "1353b83c3783abddccc8c9151242588aeac3c29d",
};
